import { Injectable } from '@angular/core';

// import typings
import { createRxDatabase } from 'rxdb';
import { environment } from 'src/environments/environment';
import { CLU_TICKCURRENTPIECE_SCHEMA } from '../@schemas/clu_tickcurrentpiece.schema';
import { CLU_TICKENTETE_SCHEMA } from '../@schemas/clu_tickentete.schema';
import { CLU_TICKLIGNE_SCHEMA } from '../@schemas/clu_tickligne.schema';
import { CLU_TICKREGLEMENT_SCHEMA } from '../@schemas/clu_tickreglement.schema';
import { F_ARTGAMME_SCHEMA } from '../@schemas/f_artgamme.schema';
import { F_ARTICLE_SCHEMA } from '../@schemas/f_article.schema';
import { F_CLIENT_SCHEMA } from '../@schemas/f_client.schema';
import { P_DEVICE_SCHEMA } from '../@schemas/p_device.schema';
import { P_DEVISE_SCHEMA } from '../@schemas/p_devise.schema';
import { P_PARAMS_SCHEMA } from '../@schemas/p_params.schema';
import { P_REGLEMENT_SCHEMA } from '../@schemas/p_reglement.schema';
import { RxCashDeskCollections, RxCashDeskDatabase } from './m-cashdesk-core-rxdb';
import { F_NOMENCLAT_SCHEMA } from '../@schemas/f_nomenclat.schema';
import { F_ARTCLIENT_SCHEMA } from '../@schemas/f_artclient.schema';
import { F_ARTCOMPTA_SCHEMA } from '../@schemas/f_artcompta.schema';
import { F_TARIFGAM_SCHEMA } from '../@schemas/f_tarifgam.schema';
import { F_TARIFQTE_SCHEMA } from '../@schemas/f_tarifqte.schema';
import { F_FAMCOMPTA_SCHEMA } from '../@schemas/f_famcompta.schema';
import { F_CONDITION_SCHEMA } from '../@schemas/f_condition.schema';
import { FN_PARAMS_SCHEMA } from '../@schemas/fn_params.schema';
import { PANEL_PARAMS_SCHEMA } from '../@schemas/panel_params.schema';
import { P_MODELE_IMPRESSION_SCHEMA } from '../@schemas/p_modele_impression.schema';
import { F_TARIFCOND_SCHEMA } from '../@schemas/f_tarifcond.schema';
import { P_DOSSIER_SCHEMA } from '../@schemas/p_dossier.schema';
import { CLU_COMPTET_XTMP_SCHEMA } from '../@schemas/clu_comptet.schema';
import { CLU_CASHOPS_SCHEMA } from '../@schemas/clu_cashops.schema';
import { F_COMPTEA_SCHEMA } from '../@schemas/f_comptea.schema';
import { CLU_AUTH_SESSION_SCHEMA } from '../@schemas/clu_auth_session.schema';
import { F_DEPOT_SCHEMA } from '../@schemas/f_depot.schema';
import { F_MODELE_SCHEMA } from '../@schemas/f_modele.schema';
import { F_ARTMODELE_SCHEMA } from '../@schemas/f_artmodele.schema';
import { CBSYSLIBRE_SCHEMA } from '../@schemas/cbsyslibre.schema';
import { P_SOUCHEVENTE_SCHEMA } from '../@schemas/p_souchevente';
import { VX_PARAMS_SCHEMA } from '../@schemas/vx_params.schema';
import { F_ARTENUMREF_SCHEMA } from '../@schemas/f_artenumref.schema';
import { F_COLLABORATEUR_SCHEMA } from '../@schemas/f_collaborateur.schema';
import { F_TAXE_SCHEMA } from '../@schemas/f_taxe.schema';
import { CLU_JET_SCHEMA } from '../@schemas/clu_jet.schema';
import moment from 'moment';
import { CLU_TICKDUPLICATA_SCHEMA } from '../@schemas/clu_tickduplicata.schema';
import { CLU_GIFTCARD_SCHEMA } from '../@schemas/clu_giftcard.schema';
import { F_TARIFSELECT_SCHEMA } from '../@schemas/f_tarifselect.schema';
import { F_TARIF_SCHEMA } from '../@schemas/f_tarif.schema';
import { CLU_ZLOG_SCHEMA } from '../@schemas/clu_zlog.schema';
import { CLU_ZTICKTRACE_SCHEMA } from '../@schemas/clu_zticktrace.schema';
import { F_JOURNAUX_SCHEMA } from '../@schemas/f_journaux.schema';
import { F_FAMCLIENT_SCHEMA } from '../@schemas/f_famclient.schema';
import { F_FAMTARIF_SCHEMA } from '../@schemas/f_famtarif.schema';
import { F_FAMTARIFQTE_SCHEMA } from '../@schemas/f_famtarifqte.schema';
import { REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA } from '../@schemas/remdocs_reglements_documents.schema';
import { REMDOCS_REGLEMENTS_CLIENTS_SCHEMA } from '../@schemas/remdocs_reglements_clients.schema';
import { REMDOCS_ACOMPTES_CLIENTS_SCHEMA } from '../@schemas/remdocs_acomptes_clients.schema';

const collectionSettings = {
    ['pparams']: { schema: P_PARAMS_SCHEMA, methods: { }, sync: false,
    migrationStrategies: {
        // 1 means, this transforms data from version 0 to version 1
        1: (oldDoc : any) => { oldDoc.DISPLAY_DEVICE_MESSAGES = null; return oldDoc; },
        2: (oldDoc : any) => { return oldDoc; },
    }
    },
    ['fnparams']: {
        schema: FN_PARAMS_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            // 1 means, this transforms data from version 0 to version 1
            1: (oldDoc : any) => { oldDoc.FN_REMISEG_ENABLED = false; oldDoc.FN_REMISEG_PARAMS = undefined; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.FN_FOND_CAISSE_ENABLED = false; oldDoc.FN_FOND_CAISSE_PARAMS = undefined; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.FN_MVTS_CAISSE_ENABLED = false; oldDoc.FN_MVTS_CAISSE_PARAMS = undefined; return oldDoc; },
            4: (oldDoc : any) => { oldDoc.FN_RETOURS_ENABLED = false; oldDoc.FN_RETOURS_PARAMS = undefined; return oldDoc; },
            5: (oldDoc : any) => { oldDoc.FN_CARTECADEAUX_ENABLED = false; oldDoc.FN_CARTECADEAUX_PARAMS = undefined; return oldDoc; },
            6: (oldDoc : any) => { oldDoc.FN_CASHOPTS_ENABLED = false; oldDoc.FN_CASHOPTS_PARAMS = undefined; return oldDoc; },
            7: (oldDoc : any) => { oldDoc.FN_BALANCES_ENABLED = false; oldDoc.FN_BALANCES_PARAMS = undefined; return oldDoc; },
            8: (oldDoc : any) => { oldDoc.FN_MODIFPRIX_ENABLED = false; oldDoc.FN_MODIFPRIX_PARAMS = undefined; return oldDoc; },
            9: (oldDoc : any) => { oldDoc.FN_QTENEG_ENABLED = false; oldDoc.FN_QTENEG_PARAMS = undefined; return oldDoc; }
        }
    },
    ['vxparams']: {
        schema: VX_PARAMS_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { }
    },
    ['panelparams']: { schema: PANEL_PARAMS_SCHEMA, methods: { }, sync: false },
    ['pdevice']: { schema: P_DEVICE_SCHEMA, methods: { }, sync: false,
                   migrationStrategies: {
                    1: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OUVERTURE_FOND_CAISSE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_THEORIQUE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_CAISSE = 0; oldDoc.CAISSE_SESSION_CLOTURE_SOLDE_ECART = 0; return oldDoc; },
                    2: (oldDoc : any) => { oldDoc.C_SUPERVISEURS_IDS = ''; oldDoc.DEVICES_SUPERVISEURS = ''; return oldDoc; },
                    3: (oldDoc : any) => { oldDoc.C_DO_SOUCHE = 0; return oldDoc; },
                    4: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OFFLINE_TRRSA_PK = null; return oldDoc; },
                    5: (oldDoc : any) => { oldDoc.LASTSEQ_TICKET = null; oldDoc.LASTSEQ_DUPLICATA = null; return oldDoc; },
                    6: (oldDoc : any) => { oldDoc.C_N_ANALYTIQUE = 0; oldDoc.C_CA_NUM = ''; return oldDoc; },
                    7: (oldDoc : any) => { oldDoc.C_CO_NO_MODE = 0; oldDoc.C_CO_NO = 0; return oldDoc; },
                    8: (oldDoc : any) => { oldDoc.CLU_AGENT_REQUIRED = false; return oldDoc; },
                    9: (oldDoc : any) => { oldDoc.SESSION_TEST_ENV = false; oldDoc.SESSION_TEST_CODE = ''; return oldDoc; },
                    10: (oldDoc : any) => { oldDoc.RUN_ONLY_ON_DEVICE = false; oldDoc.DEVICE_ID_ALLOWED = ''; return oldDoc; },
                    11: (oldDoc : any) => { oldDoc.CAISSE_SESSION_OUVERTURE_FH_UTC = null; oldDoc.CAISSE_SESSION_CLOTURE_FH_UTC = null; return oldDoc; },
                    12: (oldDoc : any) => { return oldDoc; },
                    13: (oldDoc : any) => { oldDoc.CLOTURE_SOLDE_FOND_CAISSE = null; oldDoc.CLOTURE_DECOMPTE_FOND_CAISSE_ITEMS = null; return oldDoc; },
                }
    },
    ['farticle']: {
        schema: F_ARTICLE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.ARTSTOCK_ITEMS_JSON = ''; oldDoc.ARTVTECLU_ITEMS_JSON = ''; oldDoc.AR_SUIVISTOCKLIB = ''; oldDoc.ARTSTOCK_TOT = 0; oldDoc.ARTVTECLU_TOT = 0; oldDoc.STOCKESTIME_TOT = 0; return oldDoc; },
                               2: (oldDoc : any) => { oldDoc.HGLT_IS_IMG = false; oldDoc.HGLT_IMG_DATA = ''; return oldDoc; },
                               3: (oldDoc : any) => { oldDoc.EXTRA = ''; return oldDoc; },
                               4: (oldDoc : any) => { oldDoc.AR_NOTIMP = false; return oldDoc; },
                               5: (oldDoc : any) => { oldDoc.AR_FACTPOIDS = 0; oldDoc.AR_POIDSNET = 0; oldDoc.AR_POIDSBRUT = 0; return oldDoc; } }
    },
    ['fdepot']: { schema: F_DEPOT_SCHEMA, methods: { }, sync: false },
    ['fcollaborateur']: { schema: F_COLLABORATEUR_SCHEMA, methods: { }, sync: false },
    ['fartgamme']: { schema: F_ARTGAMME_SCHEMA, methods: { }, sync: false },
    ['fartenumref']: { schema: F_ARTENUMREF_SCHEMA, methods: { }, sync: false },
    ['ftarifgam']: { schema: F_TARIFGAM_SCHEMA, methods: { }, sync: false },
    ['ftarifqte']: { schema: F_TARIFQTE_SCHEMA, methods: { }, sync: false },
    ['ftarifcond']: { schema: F_TARIFCOND_SCHEMA, methods: { }, sync: false },
    ['fartclient']: {
        schema: F_ARTCLIENT_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.AC_QTEMONT = 0; return oldDoc; } }
    },
    ['fartcompta']: { schema: F_ARTCOMPTA_SCHEMA, methods: { }, sync: false },
    ['ffamcompta']: { schema: F_FAMCOMPTA_SCHEMA, methods: { }, sync: false },
    ['ffamclient']: { schema: F_FAMCLIENT_SCHEMA, methods: { }, sync: false },
    ['ffamtarif']: { schema: F_FAMTARIF_SCHEMA, methods: { }, sync: false },
    ['ffamtarifqte']: { schema: F_FAMTARIFQTE_SCHEMA, methods: { }, sync: false },
    ['fnomenclature']: { schema: F_NOMENCLAT_SCHEMA, methods: { }, sync: false },
    ['fclient']: {
        schema: F_CLIENT_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.N_DEVISE = 0; oldDoc.N_DEVISELIB = ''; oldDoc.CT_IDENTIFIANT = ''; oldDoc.CT_APE = ''; oldDoc.CT_TELEPHONE = '';
                                                      oldDoc.CT_EMAIL = ''; oldDoc.CT_ADRESSE = ''; oldDoc.CT_COMPLEMENT = ''; oldDoc.CT_VILLE = ''; oldDoc.CT_PAYS = ''; oldDoc.CT_CODEPOSTAL = ''; oldDoc.CT_CODEREGION = '';
                                                      oldDoc.N_DEVISE_COURS = 0; oldDoc.N_DEVISE_FORMAT = ''; return oldDoc; },
                               2 : (oldDoc : any) => { oldDoc.CT_TAUX01 = 0; return oldDoc; },
                               3 : (oldDoc : any) => { oldDoc.CT_CONTACT = ''; oldDoc.CT_TELECOPIE = ''; oldDoc.CT_COMMENTAIRE = ''; oldDoc.CT_SITE = ''; oldDoc.CT_LINKEDIN = ''; oldDoc.CT_FACEBOOK = ''; oldDoc.CONTACT_ITEMS_JSON = ''; oldDoc.ADRESSE_ITEMS_JSON = ''; return oldDoc; },
                               4 : (oldDoc : any) => { oldDoc.EXTRA = 0; return oldDoc; },
                               5 : (oldDoc : any) => { oldDoc.CO_NO = 0; oldDoc.CO_NOLIB = ''; return oldDoc; },
                               6 : (oldDoc : any) => { oldDoc.CT_QUALITE = ''; return oldDoc; },
                               7 : (oldDoc : any) => { oldDoc.CT_NUMPAYEUR = oldDoc.CT_NUM; return oldDoc; },
                               8 : (oldDoc : any) => { oldDoc.CA_NUM = null; return oldDoc; } }
    },
    ['fcomptea']: {
        schema: F_COMPTEA_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.CA_NUM_PK = oldDoc.N_ANALYTIQUE + '_' + oldDoc.CA_NUM; return oldDoc; },
                               2: (oldDoc : any) => { oldDoc.IS_AFFAIRE = 0; return oldDoc; } }
    },
    ['pdevise']: { schema: P_DEVISE_SCHEMA, methods: { }, sync: false },
    ['preglement']: { schema: P_REGLEMENT_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1: (oldDoc : any) => { oldDoc.ZCD_P_DEVISE_ACCEPTED = 0; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.R_MORE_PARAMS = ''; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.SCD_TYPE = 0; oldDoc.JO_NUMCLI = ''; oldDoc.JO_NUMFOUR = ''; return oldDoc; }
        }
    },
    ['fjournaux']: { schema: F_JOURNAUX_SCHEMA, methods: { }, sync: false },
    ['fcondition']: { schema: F_CONDITION_SCHEMA, methods: { }, sync: false },
    ['clutickcurrentpiece']: { schema: CLU_TICKCURRENTPIECE_SCHEMA, methods: { }, sync: false },
    ['clutickentete']: {
        schema: CLU_TICKENTETE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1: (oldDoc : any) => { oldDoc.DO_DEVISELIB = ''; oldDoc.DO_DEVISE_FORMAT = ''; oldDoc.DO_DEVISE_INV = 0; return oldDoc; },
                               2: (oldDoc : any) => { oldDoc.DO_COORD02 = ''; oldDoc.DO_COORD03 = ''; oldDoc.DO_COORD04 = ''; return oldDoc; },
                               3: (oldDoc : any) => { oldDoc.DO_REM_CONFLICT_MODE = 0; oldDoc.CT_TAUX01 = 0; return oldDoc; },
                               4: (oldDoc : any) => { oldDoc.ZSTORAGE_MODE = 0; return oldDoc; },
                               5: (oldDoc : any) => { oldDoc.LC_CARTE_NUM = ''; return oldDoc; },
                               6: (oldDoc : any) => { oldDoc.DE_NO = 0; oldDoc.DE_INTITULE = ''; return oldDoc; },
                               7: (oldDoc : any) => { oldDoc.DO_PRINT_NB = 0; oldDoc.DO_PRINT_AT = undefined; oldDoc.DO_PRINT_LAST = undefined;
                                                      oldDoc.DO_EMAIL_NB = 0; oldDoc.DO_EMAIL_AT = undefined; oldDoc.DO_EMAIL_LAST = undefined;
                                                      oldDoc.DO_EMAIL_1 = undefined; oldDoc.DO_EMAIL_2 = undefined; oldDoc.DO_EMAIL_3 = undefined; return oldDoc; },
                               8: (oldDoc : any) => { oldDoc.CL_EXTRAS = undefined; return oldDoc; },
                               9: (oldDoc : any) => { oldDoc.DO_SOUCHE = 0; oldDoc.DO_SOUCHELIB = ''; return oldDoc; },
                               10: (oldDoc : any) => { oldDoc.CO_LIB = ''; return oldDoc; },
                               11: (oldDoc : any) => { oldDoc.DO_DATE_UTC = oldDoc.DO_DATE ? moment(oldDoc.DO_DATE).utc().format('YYYYMMDDHHmmss') : ''; oldDoc.DO_TYPE_OP = ''; oldDoc.DO_NB_LIGNES = 0; oldDoc.CLU_APP_VERSION = ''; oldDoc.DO_PIECE_INTERNAL_PREVIOUS = ''; oldDoc.DO_SIGNATURE_OFFLINE = 0; oldDoc.DO_SIGNATURE_DATETIME = '';
                                                       oldDoc.DO_SIGNATURE_REPORT = 0; oldDoc.DO_SIGNATURE = ''; oldDoc.DO_SIGNATURE_PREVIOUS = ''; oldDoc.DO_SIGNATURE_DATA = ''; oldDoc.DO_TAXE_ITEMS_JSON = ''; return oldDoc; },
                               12: (oldDoc : any) => { oldDoc.DO_TAXES = 0; return oldDoc; },
                               13: (oldDoc : any) => { oldDoc.DO_DATEDEBUT = ''; oldDoc.DO_DATEFIN = ''; oldDoc.DO_REMISE_MT = 0; return oldDoc; },
                               14: (oldDoc : any) => { oldDoc.DO_RG_ESP_RECU_TOT = 0; oldDoc.DO_RG_ESP_RENDU_TOT = 0; return oldDoc; },
                               15: (oldDoc : any) => { oldDoc.DO_MOREPARAMS_JSON = ''; return oldDoc; },
                               16: (oldDoc : any) => { oldDoc.CA_NUM = ''; oldDoc.CA_INTITULE = ''; return oldDoc; },
                               17: (oldDoc : any) => { oldDoc.DO_RG_MONTANTECART = 0; oldDoc.DO_MONTANTREGLE_F = 0; return oldDoc; },
                               18: (oldDoc : any) => { oldDoc.DO_TOT_QTE = 0; oldDoc.DO_TOTALTTC_P = 0; return oldDoc; },
                               19: (oldDoc : any) => { oldDoc.ZSYNCAGENTUP_FLAG = 0; oldDoc.ZSYNCAGENTUP_STATUS = ''; oldDoc.ZSYNCAGENTUP_ERROR_MESSAGE = ''; oldDoc.ZSYNCAGENTUP_DATETIME = ''; oldDoc.ZSYNCAGENTUP_FEEDID = ''; return oldDoc; },
                               20: (oldDoc : any) => { oldDoc.DO_GID = ''; return oldDoc; }
                            }
    },
    ['clutickligne']: {
        schema: CLU_TICKLIGNE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1: (oldDoc : any) => { oldDoc.DL_REMISE02REM_VALEUR = 0; oldDoc.DL_REMISE03REM_VALEUR = 0; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.DL_REMISE_LIB = ''; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.DL_REMISE = 0; return oldDoc; },
            4: (oldDoc : any) => { oldDoc.DL_REMISEG = 0; return oldDoc; },
            5: (oldDoc : any) => { oldDoc.DL_PRIXUNITAIRE_NC = oldDoc.DL_PRIXUNITAIRE; oldDoc.DL_PUTTC_NC = oldDoc.DL_PUTTC; return oldDoc; },
            6: (oldDoc : any) => { oldDoc.FA_CODEFAMILLE = ''; return oldDoc; },
            7: (oldDoc : any) => { oldDoc.DL_LCREC = 0; oldDoc.DL_LCREC_DATE = undefined; oldDoc.LC_REC_PTS_NB = 0; oldDoc.LC_PG_GID = undefined; oldDoc.LC_REC_GID = undefined; oldDoc.LC_REC_TYPE = 0; return oldDoc; },
            8: (oldDoc : any) => { oldDoc.DE_NO = 0; oldDoc.DE_INTITULE = ''; oldDoc.LS_NOSERIE = ''; oldDoc.LS_COMPLEMENT = ''; oldDoc.LS_PEREMPTION = undefined; oldDoc.LS_FABRICATION = undefined; oldDoc.LS_QTE = oldDoc.DL_QTE; return oldDoc; },
            9: (oldDoc : any) => { oldDoc.DL_GIFTCARD = 0; oldDoc.DL_GF_CARTE_NUM = ''; oldDoc.DL_GF_CARTE_DESIGNATION = ''; oldDoc.DL_GF_C_TOTAL_TTC_INIT = 0; oldDoc.DL_GF_DATE_DEBUT = undefined; oldDoc.DL_GF_DATE_EXP = undefined; return oldDoc; },
            10: (oldDoc : any) => { return oldDoc; },
            11: (oldDoc : any) => { oldDoc.CL_EXTRAS = undefined; return oldDoc; },
            12: (oldDoc : any) => { oldDoc.DL_REMISE_MT = undefined; return oldDoc; },
            13: (oldDoc : any) => { oldDoc.DL_MONTANTTTC_AVANTREMISE = undefined; return oldDoc; },
            14: (oldDoc : any) => { oldDoc.DO_GID = ''; return oldDoc; }
        }
    },
    ['clutickreglement']: {
        schema: CLU_TICKREGLEMENT_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1: (oldDoc : any) => { oldDoc.RG_PROV = 0; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.N_DEVISE_ENABLE = false; oldDoc.N_DEVISE = 0; oldDoc.N_DEVISE_LIB = ''; oldDoc.RG_COURS = 0; oldDoc.RG_MONTANTDEV = 0; return oldDoc; },
            3: (oldDoc : any) => { oldDoc.RG_REFERENCE = ''; return oldDoc; },
            4: (oldDoc : any) => { oldDoc.RG_ECART = 0; oldDoc.JO_NUMECART = ''; oldDoc.CG_NUMECART = ''; oldDoc.RG_MONTANTECART = 0; oldDoc.RG_MONTANTECART_F = 0; return oldDoc; },
            5: (oldDoc : any) => { oldDoc.RG_ESP_RECU = 0; oldDoc.RG_ESP_RENDU = 0; return oldDoc; },
            6: (oldDoc : any) => { oldDoc.RG_MONTANT_F = 0; return oldDoc; },
            7: (oldDoc : any) => { oldDoc.DO_GID = ''; return oldDoc; }
        }
    },
    ['clutickduplicata']: {
        schema: CLU_TICKDUPLICATA_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
        }
    },
    ['clucomptetxtmp']: { schema: CLU_COMPTET_XTMP_SCHEMA, methods: { }, sync: false,
    migrationStrategies: {
        1: (oldDoc : any) => { oldDoc.CT_NUM_FROM = ''; return oldDoc; }
    }  },
    ['clucashops']: { schema: CLU_CASHOPS_SCHEMA, methods: { }, sync: false },
    ['clugiftcard']: { schema: CLU_GIFTCARD_SCHEMA, methods: { }, sync: false },
    ['cluzticktrace']: { schema: CLU_ZTICKTRACE_SCHEMA, methods: { }, sync: false },
    ['cluzlog']: { schema: CLU_ZLOG_SCHEMA, methods: { }, sync: false },
    ['pmodeleimpression']: { schema: P_MODELE_IMPRESSION_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1: (oldDoc : any) => { oldDoc.TYPE_MODELE_IMPRESSION = 1; return oldDoc; },
            2: (oldDoc : any) => { oldDoc.IMPORT_ID = null; return oldDoc; },
        }
    },
    ['pdossier']: { schema: P_DOSSIER_SCHEMA, methods: { }, sync: false,
    migrationStrategies: {
        1: (oldDoc : any) => { oldDoc.D_SIRET = ''; oldDoc.D_APE = ''; oldDoc.D_IDENTIFIANT = ''; return oldDoc; },
        2: (oldDoc : any) => { oldDoc.D_RCS = ''; return oldDoc; }
    } },
    ['cluauthsession']: { schema: CLU_AUTH_SESSION_SCHEMA, methods: { }, sync: false,
    migrationStrategies: {
        1: (oldDoc : any) => { return oldDoc; },
        2: (oldDoc : any) => { return oldDoc; }
    }   },
    ['fmodele']: { schema: F_MODELE_SCHEMA, methods: { }, sync: false },
    ['fartmodele']: { schema: F_ARTMODELE_SCHEMA, methods: { }, sync: false },
    ['psouchevente']: { schema: P_SOUCHEVENTE_SCHEMA, methods: { }, sync: false },
    ['ftaxe']: { schema: F_TAXE_SCHEMA, methods: { }, sync: false },
    ['ftarif']: { schema: F_TARIF_SCHEMA, methods: { }, sync: false },
    ['ftarifselect']: { schema: F_TARIFSELECT_SCHEMA, methods: { }, sync: false },
    ['cbsyslibre']: { schema: CBSYSLIBRE_SCHEMA, methods: { }, sync: false },
    ['clujet']: { schema: CLU_JET_SCHEMA, methods: { }, sync: false },
    ['remdocs_reglements_documents']: { schema: REMDOCS_REGLEMENTS_DOCUMENTS_SCHEMA, methods: { }, sync: false, migrationStrategies: {
      1: (oldDoc : any) => { oldDoc.CT_NUM = ''; oldDoc.CT_INTITULE = ''; return oldDoc; }
    } },
    ['remdocs_reglements_clients']: { schema: REMDOCS_REGLEMENTS_CLIENTS_SCHEMA, methods: { }, sync: false, migrationStrategies: {
      1: (oldDoc : any) => { oldDoc.CT_NUM = ''; oldDoc.CT_INTITULE = ''; return oldDoc; }
    } },
    ['remdocs_acomptes_clients']: { schema: REMDOCS_ACOMPTES_CLIENTS_SCHEMA, methods: { }, sync: false, migrationStrategies: {
      1: (oldDoc : any) => { oldDoc.CT_NUM = ''; oldDoc.CT_INTITULE = ''; return oldDoc; }
    } },
};

/**
 * creates the database
 */
async function _create(): Promise<RxCashDeskDatabase> {
    //removeRxDatabase('dblinkupcashdesk', environment.getRxStorage());
    environment.addRxDBPlugins();
    console.log('CashDeskCoreRxDbService: creating database..');
    const db = await createRxDatabase<RxCashDeskCollections>({
        name: 'dblinkupcashdesk',
        storage: environment.getRxStorage(),
        multiInstance: environment.multiInstance,
        // password: 'myLongAndStupidPassword' // no password needed
    });
    console.log('CashDeskCoreRxDbService: created database');

    if (!environment.isServerSideRendering) {
        // write to window for debugging
        (window as any)['db'] = db;
    }

    // show leadership in title
    if (environment.multiInstance) {
        db.waitForLeadership()
            .then(() => {
                console.log('isLeader now');
                document.title = '♛ ' + document.title;
            });
    }

    // create collections
    console.log('CashDeskCoreRxDbService: create collections');
    await db.addCollections(collectionSettings);


    // hooks
    /*console.log('CashDeskCoreRxDbService: add hooks');
    console.log(db.collections);
    db.collections.farticle.preInsert(function (docObj: RxFArticleDocumentType) {
        const AR_REF = docObj.AR_REF;
        return db.collections.farticle
            .findOne({ selector: { AR_REF } })
            .exec()
            .then((has: RxFArticleDocument | null) => {
                if (has != null) {
                    alert('another article already has the AR_REF ' + AR_REF);
                    throw new Error('AR_REF already there');
                }
                return db;
            });
    }, false);*/

    console.log('CashDeskCoreRxDbService: created');

    return db;
}


let initState: null | Promise<any> = null;;
let DB_INSTANCE: RxCashDeskDatabase;

/**
 * This is run via APP_INITIALIZER in app.module.ts
 * to ensure the database exists before the angular-app starts up
 */
export async function initDatabase_CashDeskRxDb() {
    /**
     * When server side rendering is used,
     * The database might already be there
     */
    if (!initState) {
        initState = _create().then(db => {
          DB_INSTANCE = db;
        });
    }
    await initState;
}

@Injectable()
export class CashDeskCoreRxDbService {
    get db(): RxCashDeskDatabase {
        return DB_INSTANCE;
    }
}
